var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5461 7.01268C41.0653 10.0417 42.5804 13.9355 42.5804 18.1832V40.8923C42.5804 44.4295 39.7129 47.2971 36.1757 47.2971H11.8244C8.28722 47.2971 5.41968 44.4296 5.41968 40.8923V7.10783C5.41968 3.57067 8.28713 0.703125 11.8244 0.703125H25.1005C29.4707 0.703125 33.4665 2.307 36.5311 4.95818",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1956 0.704346C26.6711 2.10001 27.5121 4.04164 27.5121 6.07796V7.81017C27.5121 11.7713 30.7233 14.9825 34.6844 14.9825H36.5141C38.8131 14.9825 41.0041 15.939 42.5702 17.6143",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6809 38.9039C18.6952 40.4901 21.2371 41.4364 24 41.4364C30.5393 41.4364 35.8404 36.1352 35.8404 29.596C35.8404 23.0568 30.5393 17.7556 24 17.7556C17.4608 17.7556 12.1597 23.0568 12.1597 29.596C12.1597 32.3589 13.106 34.9008 14.6922 36.9152",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33.4683C26.1385 33.4683 27.8721 31.7347 27.8721 29.5962C27.8721 27.4577 26.1385 25.7241 24 25.7241C21.8615 25.7241 20.1279 27.4577 20.1279 29.5962C20.1279 31.7347 21.8615 33.4683 24 33.4683Z",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1173 6.96973H10.9305C9.86483 6.96973 9.00098 7.83367 9.00098 8.89927V10.0554C9.00098 11.1211 9.86483 11.985 10.9305 11.985H22.1173C23.183 11.985 24.0468 11.1211 24.0468 10.0554V8.89927C24.0469 7.83358 23.183 6.96973 22.1173 6.96973Z",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1729 29.5962H37.8274",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43.4234V15.7688",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0164 6.96973V11.985",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0317 6.96973V11.985",
    stroke: "#102E7A",
    strokeWidth: 1.40616,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/Domain.1ed872fccb6bc96db1e2e5831fb4415a.svg";
export { ForwardRef as ReactComponent };